module.exports = __webpack_public_path__ + "img/page-04.abd96c26.jpg";